module.exports = {
    debug: false,
    breakpoints: {
        small: 0,
        medium: 768,
        large: 1024,
        xlarge: 1200,
        xxlarge: 1440
    },
};